import Vue from "vue";
import Vuex from "vuex";
import config from "./tab.conf";
import * as constant from "@/utils/constant";
import {
  postQuick,
  postHead,
  postHeadNew,
  postResult,
  getTags,
  checkLogin,
  getCityList,
  getAllDistrict,
  getAddressGray,
  getUserAddressList,
  getAddressInfo,
  getCartCount,
  getRecommenGoods
} from "./assets/js/api";
import throttle from "lodash/throttle";
import { getQueryString, gioClickHandle, unionFlag, getResultObj, getSearchWhere, getFilterParam, checkUnifyShop, getPath } from "./utils";
import { fetchTagsList, dealTagsList } from "./tags";
import { TLang } from "./utils/lang";
import { hotelFilter } from "./utils/hotelFilter";
import { lexiangFilter } from "./utils/lexiangFilter";
import { data } from "./utils/lang/language";
import { insertHotGoodsByPageIndex } from "./utils/recommendgood";
// import { getCatchAddress } from "./utils/locationApi/location";

import { getCatchAddress } from 'dflocationsdk';
import {
  checkFromChannel
} from "./utils";
import { checkXcx, checkLeFuXcx } from "./utils/checkXcx";

Vue.use(Vuex);

let pathname = ''
let serchHeaderParams = {}
let newEntityRouteState = {};
if (constant.newEntityInfo) {
  for (var key in constant.newEntityInfo) {
    newEntityRouteState[key] = {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false
    };
  }
}

let pageSizeObj = {}

const flatArray = (arr) => {
  if (Array.isArray(arr)) {
    return arr.reduce((ret, item) => ret.concat(item), []);
  }
  return arr
}

const deepClone = obj => {
  if (obj === null) return null;
  let clone = Object.assign({}, obj);
  Object.keys(clone).forEach(
    key =>
    (clone[key] =
      typeof obj[key] === 'object' ? deepClone(obj[key]) : obj[key])
  );
  if (Array.isArray(obj)) {
    clone.length = obj.length;
    return Array.from(clone);
  }
  return clone;
};

function getKeyMapOfList(list) {
  const dataList = {}

  if (Array.isArray(list)) {
    list.forEach((item) => {
      const key = `${item.categoryId || item.channel || item.gioChannel}-${item.id}-${item._idNumber}`
      dataList[key] = item
     })
  }

  return dataList
}

function merageNameOfSame (allList, list) {
  if (allList.length === 0) {
    return list
  }
 const keyMap = getKeyMapOfList(list)
 const keyMap2 = {...keyMap}
 const merageList = allList.map((item) => {
    const isAllKey = `${item.categoryId || item.channel || item.gioChannel}-${item.id}-${item._idNumber}`
    if (keyMap[isAllKey] ) {
      delete keyMap2[isAllKey]
      return keyMap[isAllKey]
    }
    return item
  })

  return merageList.concat(Object.values(keyMap2))
}
const store = new Vuex.Store({
  state: {
    tabs: [],
    tabsLoading: true,
    loginInfo: {},
    cityInfo: {},
    provinceList: [],
    addressGray: false,
    userAddressList: [],
    cartCount: -1,
    recommendList: [],
    cardInfos: [],
    suggestWords: [],
    noStockGrayStatus: true,

    businessFrontTags: [],
    businessFrontTagId: null,
    businessTagPageIndex: 3,

    addressInfo: {
      provinceId: 9,
      provinceName: "上海市",
      cityName: "上海",
      cityId: 145,
      regionId: 1222,
      regionName: "黄浦区",
      streetId: 16777,
      streetName: "南京东路街道",
    },
    singleChannel: '',
    showLocationNo: null,
    locationInfo: null,
    lxPriceInfo: null,
    lxLocationInfo: null,
    searchKey: "",
    quick: {
      products: [],
      searches: [],
      count: 0,
      keyword: "",
      cardInfos: [],
      suggestWords: [],
    },
    home: {
      category: [],
      searches: [],
      topOrgList: [],
      isAllOrgData: false,
      fetching: true,
      loadEnd: false,
      loadError: false,
      orgTotal: 0,
      totalCount: 0,
      isGuide: null,
    },
    cake: {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false,
    },
    sxChange: {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false,
    },
    mart: {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false,
    },
    offline: {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false,
    },

    cinema: {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false,
    },
    coupon: {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false,
    },
    drama: {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false,
    },
    fitness: {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false,
    },
    health: {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false,
    },
    life: {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false,
    },
    book: {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false,
    },
    jdyx: {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false,
    },
    xmyp: {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false,
    },
    healthy: {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false,
    },
    movie: {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false,
    },
    scenery: {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false,
    },
    spree: {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false,
    },
    tour: {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false,
    },
    healthServices: {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false,
    },
    oralHealth: {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false,
    },
    examMeal: {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false,
    },
    examOrg: {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false,
    },
    wyyx: {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false,
    },
    listen: {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false,
    },
    study: {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false,
    },
    chaoshi: {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false,
    },
    hotel: {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false,
      loading: false,
    },
    lxActivity: {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false,
    },
    lxHotel: {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false,
    },
    lxScenery: {
      category: [],
      searches: [],
      fetching: true,
      loadEnd: false,
      loadError: false,
    },
    allQuery: {},
    ...newEntityRouteState
  },
  mutations: {
    initParmasAsync(state, payload) {
      serchHeaderParams = { ...payload, }
    },
    initData(state, { products, val, isSensitive, categorys, name, businessFrontTags }) {
      state.tabs = products.length ? products : [];
      state.tabsLoading = false

      state.businessFrontTags = businessFrontTags || [];

      try {
        if (name) { pathname = name }
        state[name || pathname].category = categorys || [];
      } catch (error) {
        console.error(error)
      }

      if (!state.tabs.length) {
        for (let key in state) {
          if (!Array.isArray(key) && state.hasOwnProperty(key)) {
            state[key].hasOwnProperty("category") && (state[key].category = []);
            state[key].hasOwnProperty("searches") && (state[key].searches = []);
          }
        }
      }


    },
    setbusinessFrontTagId(state, id) {
      state.businessFrontTagId = id;
    },
    setRecordWord(state, payload) {
      const { isSensitive, key } = payload
      if (!isSensitive) {
        // 存储搜索历史记录
        let LOCALRECORD = localStorage.getItem("record");
        let arr;

        if (LOCALRECORD) {
          // 先添加
          arr = JSON.parse(LOCALRECORD);
          localStorage.setItem("record", JSON.stringify([key, ...arr]));
          // 再去重复
          LOCALRECORD = localStorage.getItem("record");
          arr = [...new Set(JSON.parse(LOCALRECORD))];
          arr = arr.length > 20 ? arr.slice(0, 20) : arr;
          localStorage.setItem("record", JSON.stringify(arr));
        } else {
          localStorage.setItem("record", JSON.stringify([key]));
        }
      }
    },
    updateData(
      state,
      {
        searches = [],
        name,
        pageIndex,
        totalNumber,
        value,
        topOrgList,
        isAllOrgData,
        totalCount,
        orgTotal,
        onlyGetOrg,
        recommendList,
        isGuide,
        businessFrontTags,
        businessFrontTagId,
        allRecommenGoodsResult
      }
    ) {
      if (recommendList) state.recommendList = recommendList;
      // if (businessFrontTags) state.businessFrontTags = businessFrontTags;
      if (allRecommenGoodsResult) state['allRecommenGoodsResult'] = allRecommenGoodsResult;

      // if (category) {
      //   state[name].category = category;
      // }
      if (isGuide >= 0) {
        state[name].isGuide = isGuide;
      }


      if (pageIndex === 1) {
        state[name].fetching = totalNumber === 1 ? !value : value;
        state[name].loadEnd = !value;
        state[name].loadError = !value;
        
        let _searchData =  deepClone(searches)
        state[name].searches = _searchData
        state[name].totalCount = totalCount || 0;
      } else {
        // debugger
        if (pageIndex === totalNumber) {
          state[name].fetching = !value;
          state[name].loadEnd = value;
          state[name].loadError = !value;
        } else {
          state[name].fetching = searches.length ? value : !value;
          state[name].loadEnd = searches.length ? !value : value;
          state[name].loadError = !value;
        }
        let _searchData = deepClone(merageNameOfSame(state[name].searches, searches))  ;
         state[name].searches = _searchData
      }
      if (onlyGetOrg) {
        state[name].topOrgList = topOrgList || [];
        state[name].isAllOrgData = isAllOrgData ? true : false;
        state[name].orgTotal = orgTotal || 0;
      }
    },
    fastMatch(
      state,
      { products, searches, count, keyword, cardInfos, suggestWords }
    ) {
      state.quick.products = products;
      state.quick.searches = searches;
      state.quick.suggestWords = suggestWords;
      state.quick.count = count;
      state.quick.keyword = keyword;
      state.quick.cardInfos = cardInfos;
    },
    setSearchKey(state, key) {
      state.searchKey = key;
    },
    setFetchState(state, { name, value }) {
      state[name].fetching = value;
    },
    setLoadErrorState(state, { name, value }) {
      state[name].loadError = value;
    },
    setLoginInfo(state, loginInfo) {
      state.loginInfo = loginInfo;
    },
    setCityInfo(state, cityInfo) {
      state.cityInfo = cityInfo;
    },
    setProvince(state, provinceList) {
      state.provinceList = provinceList;
    },
    setAddressGray(state, addressGray) {
      state.addressGray = addressGray;
    },
    setUserAddressList(state, userAddressList) {
      state.userAddressList = userAddressList;
    },
    setAddressInfo(state, addressInfo) {
      state.addressInfo = addressInfo;
    },
    setSingleChannel(state, singleChannel) {
      state.singleChannel = singleChannel;
    },
    setLocationNoResult(state, { ...showFlag }) {
      state.showLocationNo = showFlag.needLocation;
      state.locationInfo = showFlag.location && showFlag.location.location || JSON.parse(localStorage.getItem("systemLoaction")) && JSON.parse(localStorage.getItem("systemLoaction")).location;
    },
    setLxPrice(state, priceInfo) {
      state.lxPriceInfo = priceInfo;
    },
    setLxLocation(state, locationInfo) {
      state.lxLocationInfo = locationInfo;
    },
    setCartCount(state, count) {
      state.cartCount = count;
    },
    setCardsInfo(state, { cardInfos }) {
      state.cardInfos = cardInfos;
    },
    setSuggestWords(state, { suggestWords }) {
      state.suggestWords = suggestWords;
    },
    setAllQuery(state, payload) {
      state.allQuery = payload;
    },
    setLoadingState(state, { name, value }) {
      state[name].loading = value;
    },
    setBusinessFrontTags(state, { businessFrontTags }) {
      state.businessFrontTags = businessFrontTags;
    },
    // setBusTagChange(state, value) {
    //   state.businessFrontValue = value;
    // },
    setNoStockGrayStatus(state, { noStockGrayStatus }) {
      state.noStockGrayStatus = noStockGrayStatus;
    },
    setAllRecommenGoodsResult(state, payload) {
      if (Array.isArray(payload)) {
        state.allRecommenGoodsResult = payload;
       return 
      }
      
      state.allRecommenGoodsResult = payload;
    },
  },
  actions: {

    initDataAsync({ commit, state }, payload) {
      payload.businessTagPageIndex = 3
      // 入参singleChannel需要转成布尔值
      if (payload.singleChannel) {
        payload.singleChannel = true
      }

      payload = { ...serchHeaderParams, ...payload }
      if (checkFromChannel() && checkXcx() && !checkLeFuXcx()) {
        payload.customization = 1;
        if (!payload.productTypes||payload.productTypes.length===0) {
          // console.log(localStorage.getItem("RETURN_URL"));
          payload.productTypes = checkFromChannel();
        } else if (!Array.isArray(payload.productTypes)) {
          let arr = [payload.productTypes];
          payload.productTypes = arr;
        }
          const list = payload.productTypes
          if (list.includes('景点') && !list.includes('玩乐')) {
            payload.productTypes = [...list, '玩乐']
          } else if (list.includes('玩乐') && !list.includes('景点')) {
            payload.productTypes = [...list, '景点']
          }
      }
      return postHeadNew(payload).then((res) => {
        // 获取头部频道Tab数据
        let { searchResultBaseDtos, searchListResponseDto, businessFrontTags } = res.data;
        // let hasRes = searchResultBaseDtos ? "有" : "无";
        // // 触发 埋点
        // gioClickHandle("DF_elementClick", {
        //   df_searchKeyword: payload.key,
        //   df_ifSearchResult: hasRes,
        //   df_ifLogin: state.loginInfo.loginFlag ? "是" : "否",
        //   df_cityid: state.loginInfo.city,
        //   df_modulename: "搜索关键词",
        //   df_elementname: "搜索关键词",
        // });

        let arr;
        let configNameArr = config.map((con) => {
          return con.name;
        });
        if (!searchResultBaseDtos)
          searchResultBaseDtos = [
            { defaultFlag: true, list: null, name: "全部" },
          ];
        if (searchResultBaseDtos && searchResultBaseDtos.length > 0) {
          // 判断频道配置中是否包含该频道
          let newPro = searchResultBaseDtos.filter((item) =>
            configNameArr.includes(item.name)
          );
          arr = newPro.map((pro, index) => {
            for (let i = 0, len = config.length; i < len; i += 1) {
              const conf = config[i];
              if (conf.name == pro.name) {
                return {
                  ...pro,
                  path: conf.path,
                  index,
                  name: pro.name
                };
              }
            }
          });
        }

        const { products, category } = searchListResponseDto || {};
        const _categorys = (getSearchWhere(products, category, searchListResponseDto))
        // 不是敏感词，才加入最近搜索
        if (payload && payload.isSensitive) {
          commit("initData", {
            products: arr ? arr : [],
            categorys: _categorys,
            val: payload.key,
            isSensitive: true,
            name: payload.name,
            businessFrontTags
          });
        } else {
          commit("initData", {
            products: arr ? arr : [],
            categorys: _categorys,
            val: payload.key,
            name: payload.name,
            businessFrontTags
          });
        }
        return {
          tabs: products && products.length ? products : [],
          tabsLoading: false
        }
      });
      // postHead(payload).then(res => {

      //   let { searchResultBaseDtos } = res.data;
      //   let hasRes = searchResultBaseDtos ? '有' : '无';
      //   // 触发 埋点
      //   gioClickHandle('DF_elementClick', {
      //     df_searchKeyword: payload.key,
      //     df_ifSearchResult: hasRes,
      //     df_ifLogin: state.loginInfo.loginFlag ? '是' : '否',
      //     df_cityid: state.loginInfo.city,
      //     df_modulename: '搜索关键词',
      //     df_elementname: '搜索关键词'
      //   })

      //   let arr;
      //   let configNameArr = config.map((con) => {
      //     return con.name;
      //   });
      //   if (!searchResultBaseDtos) searchResultBaseDtos = [{ defaultFlag: true, list: null, name: "全部" }]
      //   if (searchResultBaseDtos && searchResultBaseDtos.length > 0) {
      //     let newPro = searchResultBaseDtos.filter((item) => configNameArr.includes(item.name));
      //     arr = newPro.map((pro, index) => {
      //       for (let i = 0, len = config.length; i < len; i += 1) {
      //         const conf = config[i];
      //         if (conf.name == pro.name) {
      //           return {
      //             ...pro,
      //             path: conf.path,
      //             index
      //           };
      //         }
      //       }
      //     });
      //   }

      //   commit("initData", {
      //     products: arr ? arr : [],
      //     val: payload.key
      //   });
      // });
    },
    commitInitData({ commit, state }, payload) {
      // 存储搜索历史记录
      let LOCALRECORD = localStorage.getItem("record");
      let arr;

      if (LOCALRECORD) {
        // 先添加
        arr = JSON.parse(LOCALRECORD);
        localStorage.setItem("record", JSON.stringify([payload.key, ...arr]));
        // 再去重复
        LOCALRECORD = localStorage.getItem("record");
        arr = [...new Set(JSON.parse(LOCALRECORD))];
        arr = arr.length > 20 ? arr.slice(0, 20) : arr;
        localStorage.setItem("record", JSON.stringify(arr));
      } else {
        localStorage.setItem("record", JSON.stringify([payload.key]));
      }
    },
    async checkLogin({ dispatch, commit }) {
      const res = await checkLogin();
      if (res.data.loginFlag === 1) {
        dispatch("getCartCount");
        dispatch("getUserAddressList");
      }
      commit("setLoginInfo", res.data);
    },
    // async getCityList({ commit }) {
    //   const res = await getCityList();
    //   commit("setCityInfo", res.data);
    // },
    getCityList({ commit }) {
      getCityList().then((res) => {
        commit("setCityInfo", res.data);
      })
    },
    // async getAllDistrict({ commit }) {
    //   const res = await getAllDistrict();
    //   commit("setProvince", res.data.body);
    // },
    getAllDistrict({ commit }) {
      getAllDistrict().then((res) => {
        commit("setProvince", res.data.body);
      })
    },
    async getAddressGray({ dispatch, commit }) {
      const union = unionFlag() || sessionStorage.getItem("dffl_union");
      const res = await getAddressGray({ unionCode: union || checkUnifyShop() });
      if (res.data.body) {
        dispatch("getCityList");
        dispatch("getAllDistrict");
      }
      commit("setAddressGray", res.data.body)
    },
    // async getUserAddressList({ commit }) {
    //   const res = await getUserAddressList();
    //   commit("setUserAddressList", res.data.body);
    // },
    getUserAddressList({ commit }) {
      getUserAddressList().then((res) => {
        commit("setUserAddressList", res.data.body);
      })
    },
    async getCartCount({ state, commit }) {
      const addr = JSON.parse(getCatchAddress() || null)
      let address = state.addressInfo
      if (addr && addr.cityId) {
        address = {
          provinceId: addr.provinceId,
          provinceName: addr.provinceName,
          cityName: addr.cityName,
          cityId: addr.cityId,
          regionId: addr.regionId || addr.districtId,
          regionName: addr.districtName,
          streetId: addr.streetId,
          streetName: addr.streetName,
        };
      }
      const res = await getCartCount(address);
      const { code, body } = res.data;
      if (code !== 0) return;
      commit("setCartCount", body);
    },
    async getAddressInfo({ commit }) {
      const addr = JSON.parse(getCatchAddress() || null)
      if (addr && addr.cityId) {
        const address = {
          provinceId: addr.provinceId,
          provinceName: addr.provinceName,
          cityName: addr.cityName,
          cityId: addr.cityId,
          regionId: addr.regionId || addr.districtId,
          regionName: addr.districtName,
          streetId: addr.streetId,
          streetName: addr.streetName,
        };
        commit("setAddressInfo", address);
      } else {
        const res = await getAddressInfo({
          id: getQueryString("city") || 145,
        });
        const { body, code } = res.data;
        if (code !== 0) return;
        try {
          const address = {
            provinceId: body.district && body.district.id,
            provinceName: body.district && body.district.name,
            cityName: body.city && body.city.name,
            cityId: body.city && body.city.id,
            regionId: body.region && body.region.id,
            regionName: body.region && body.region.name,
            streetId:
              (body.streets && body.streets.length && body.streets[0].id) || null,
            streetName:
              body.streets && body.streets.length && body.streets[0].name,
          };
          commit("setAddressInfo", address);
        } catch (e) {
          console.log(e);
        }
      }
    },
    // 频道内搜索
    setSingle({ commit }) {
      const singleChannel = getQueryString("singleChannel")
      commit("setSingleChannel", singleChannel);
    },
    updateLocationAsync({ commit, state }, payload) {
      // 1 显示 2 不显示
      commit("setLocationNoResult", payload);
    },
    clearAllQuery({ commit, state }, payload){
      console.log("allquery清除了");
      commit("setAllQuery",{});
    },
    updateLxPriceAsync({ commit, state }, payload) {
      commit("setLxPrice", payload);
    },
    updateLxLocationAsync({ commit, state }, payload) {
      commit("setLxLocation", payload);
    },
    updateDataAsync({ commit, state }, payload) {
      if (checkFromChannel() && checkXcx() && !checkLeFuXcx()) {
        payload.customization = 1;
        if (!payload.productTypes||payload.productTypes.length===0) {
          // console.log(localStorage.getItem("RETURN_URL"));
          payload.productTypes = checkFromChannel();
        } else if (!Array.isArray(payload.productTypes)) {
          let arr = [payload.productTypes];
          payload.productTypes = arr;
        }
      }
      payload.businessTagPageIndex = state.businessTagPageIndex
      payload.businessFrontTagId = state.businessFrontTagId
      // 入参singleChannel需要转成布尔值
      if (payload.singleChannel) {
        payload.singleChannel = true
      }

      return new Promise((resolve, reject) => {
        let isFromCategory = ''
        if (payload.fromCategory !== undefined) {
          isFromCategory = JSON.parse(JSON.stringify(payload.fromCategory));
          delete payload.fromCategory;
        }
        // 存搜索参数
        commit("setAllQuery", {...state.allQuery, ...payload, isFromCategory, });
        // console.log("state.allquery", state.allQuery )
        try {
          Promise.all([
            // 请求热门推荐
            getRecommenGoodsResultByCache(state,{...payload}, commit),
            // 请求列表结果
            postResult({...payload})
          ]).then((res) => {
            const { searchListResponseDto, businessFrontTags = [] } = res[1].data;
            if (searchListResponseDto && searchListResponseDto.searches) {
              searchListResponseDto.searches.forEach((item, index) => item._idNumber = `${payload.pageIndex}_${index}`)
            }
            console.log(payload, 'payload')

            const isNotEmpty = searchListResponseDto && searchListResponseDto.searches
            if (getPath() !== 'home' && !isNotEmpty) {
              window.location.href = origin + '/ms/home' + location.search;
              return
            }

            const { _searchesList, insertIndex, advertisingSpacs} = insertHotGoodsByPageIndex(searchListResponseDto && searchListResponseDto.searches, state['allRecommenGoodsResult'])
            const _searchListResponseDto = {
              ...searchListResponseDto,
              searches: _searchesList
            }
           
            commit('setAllRecommenGoodsResult', {
              insertIndex,
              advertisingSpacs
            })
          
            getResultObj(
              commit,
              payload,
              resolve,
              reject,
              _searchListResponseDto,
              businessFrontTags,
              isFromCategory,
              state
              )
          })
          // postResult(payload).then((res) => {
          //   const { searchListResponseDto, businessFrontTags = [] } = res.data;
          //   getResultObj(
          //     commit,
          //     payload,
          //     resolve,
          //     reject,
          //     searchListResponseDto,
          //     businessFrontTags,
          //     isFromCategory,
          //     state
          //   )
          // });
        } catch (error) {
          // 筛选分类，结果返回触发埋点
            let pathName = window.location.pathname;
            let channelName = "全部";
            if (pathName.indexOf("home") > -1) {
              channelName = "全部";
            } else if (getQueryString("productTypes")) {
              channelName = getQueryString("productTypes");
            }
            gioClickHandle("DF_elementClick", {
              df_searchKeyword: payload.key,
              df_ifSearchResult: "无",
              df_ifLogin: state.loginInfo.loginFlag ? "是" : "否",
              df_cityid: state.loginInfo.city,
              df_modulename: "搜索关键词",
              df_elementname: isFromCategory||"搜索关键词",
              df_channle: channelName,
              df_filter: getFilterParam(state.allQuery),
            });
          // 加载失败
          const { pathname } = window.location;
          const lastIndex = pathname.lastIndexOf("/");
          const name = pathname.substr(lastIndex + 1);
          commit("setLoadErrorState", {
            name: name,
            value: true
          });
        }
      });
    },
    fastMatchAsync: throttle(({ commit, state }, payload) => {
      // 入参singleChannel需要转成布尔值
      if (payload.singleChannel) {
        payload.singleChannel = true
      }
      postQuick(payload).then((res) => {
        const { searchResponseDto } = res.data;
        const { products, searches, count, keyword, cardInfos, suggestWords } =
          searchResponseDto || {};
        // console.log("suggestWords", suggestWords);
        let arr;
        let configNameArr = config.map((con) => {
          return con.name;
        });

        if (products && products.length > 0) {
          let newPro = products.filter((item) =>
            configNameArr.includes(item.productType)
          );
          arr = newPro.map((pro, index) => {
            for (let i = 0, len = config.length; i < len; i += 1) {
              const conf = config[i];
              if (conf.name == pro.productType) {
                return {
                  ...pro,
                  path: conf.path,
                  key: payload.key,
                  index: index + 1,
                };
              }
            }
          });
          // arr.push({
          //   path: config[0].path,
          //   key: payload.key,
          //   index: 0
          // });
        }

        commit("fastMatch", {
          products: arr ? arr : [],
          searches: searches ? searches : [],
          suggestWords: suggestWords ? suggestWords : [],
          count: count ? count : 0,
          keyword: keyword ? keyword : "",
          cardInfos: cardInfos ? cardInfos : [],
        });
      });
    }, 1500),
  },
});

async function getRecommenGoodsResultByCache(state, payload, commit) {
  const { pageIndex } = payload;
  const allRecommenGoodsResult = state.allRecommenGoodsResult;
  if (allRecommenGoodsResult != undefined && pageIndex != 1) {
    // 缓存数据
    const data = {
      advertisingSpacs: allRecommenGoodsResult,
      insertIndex: undefined,
    };
    return data;
  } else {
    const res = await getRecommenGoods({ ...payload }); // 原生数据
    const { advertisingSpacs } = res.data;
    const data = {
      advertisingSpacs: (advertisingSpacs || []).map((item, index) => ({
          ...item,
          sort: index
        })),
      insertIndex: undefined,
    };
    commit('setAllRecommenGoodsResult', data);
    return data;
  }
}

export default store;
